/* eslint-disable no-param-reassign */
import { properCase } from '@/model/helpers';
import { createChart } from './PDFDotPlotBullet';

export default (metric, template) => {
    const { chart, colour } = template;
    chart.h = 0;
    for (let i = 0; i < metric.submodels.length; i++) {
        const subMetric = metric.submodels[i];
        const subChart = {
            // border: { colour: '#ff0000' },
            label: metric.submodels.length > 1 && {
                text: subMetric.label,
                mb: 'h-0-1/16'
            },
            chart: createChart(subMetric, { colour })
        };
        // subChart.val.y = 0;
        chart[subMetric.id] = subChart;
    }
    if (metric.submodels.length === 1) {
        template.label.text = properCase(metric.submodels[0].label);
    }
    // template.border = { colour: '#00ff00' };
    return template;
};
